/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Patient/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function Patient({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/Patient"
  
}) {
let patientPersonValueData = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'person',
format: fromFormat.patientName,
})
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h1"
 overflowX="visible"
 overflowY="visible"
 data="patient.person"
 format="/Data/format.js patientName"
 text={patientPersonValueData}
/>
{children}
</React.Fragment>)
}